module.exports = __webpack_public_path__ + "img/post4.bb7f9f32.jpg";